export default __webpack_public_path__ + "static/media/flag-dominica.19942b3f.svg";